module.exports = __webpack_public_path__ + "img/yir-2017-detail.a5f87b93.jpg";